import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import { TBaseRequest } from '~/store/types';
import { thunkErrorHandler } from '~/store/utils';
import {
  TDataProcessingAcceptedRequest,
  TGetFormRequestAssetManagerRequest,
  TIdentificationForm,
} from '../types';
import { TManagersAndRepresentatives } from '~/modules/identification/forms/ManagersAndRepresentatives/types';

export const b2IntegrationAssetManagersPrefill = createAsyncThunk<null, TBaseRequest>(
  'identification/b2IntegrationAssetManagersPrefill',
  async ({ applicationId }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/identification/b2-integration/application/${applicationId}/asset-managers/prefill`,
        null
      );
      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const getFormDataAssetManagers = createAsyncThunk<
  TIdentificationForm,
  TGetFormRequestAssetManagerRequest
>(
  'identification/getFormDataAssetManagers',
  async ({ applicationId, managerId }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/identification/asset-managers/${managerId}/screen-forms/application/${applicationId}`,
        {
          _skipAuthRefresh: true,
        }
      );

      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const updateDataProcessingAcceptedAssetManagers = createAsyncThunk<
  TIdentificationForm,
  TDataProcessingAcceptedRequest
>(
  'identification/getFormDataAssetManagers',
  async ({ applicationId, managerId, isDataProcessingAccepted }, { rejectWithValue }) => {
    try {
      const response = await api.patch(
        `/identification/asset-managers/${managerId}/application/${applicationId}/data-processing-acceptance`,
        { isDataProcessingAccepted },
        {
          _skipAuthRefresh: true,
        }
      );

      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const getManagementStructureSyncAssetManagers = createAsyncThunk<
  TManagersAndRepresentatives,
  { applicationId: string | number }
>(
  'identification/getManagementStructureSyncAssetManagers',
  async ({ applicationId }, { rejectWithValue }) => {
    try {
      const { data } = await api.patch(
        `/identification/application/${applicationId}/management-structure/sync-asset-managers`
      );

      return data as TManagersAndRepresentatives;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
